import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import countries from './countriesReducer';
import regions from './regionsReducer';
import subdomains from './subdomainsReducer';
import spAdminDetails from './spPlatformConfigReducer';
import notifications from './notificationReducer';
import showSpinner from './spinnerReducer';
import user from './userDataReducer';
import projects from './projectsReducer';
import highlights from './highlightsReducer';
import blogs from './blogsReducer';
import pinnedBlogs from './pinnedBlogsReducer';
import usersLists from './usersListsReducer';
import modals from './modalsReducer';
import payments from './paymentsReducer';
import dashboards from './dashboardReducer';
import mobileAppVersions from './mobileAppVersionsReducer';
import sharedReducers from 'shared/reducers';

// Combines all reducers to a single reducer function
const rootReducer = combineReducers({
  user,
  showSpinner,
  countries,
  regions,
  subdomains,
  notifications,
  projects,
  highlights,
  blogs,
  pinnedBlogs,
  usersLists,
  modals,
  form: formReducer,
  router: routerReducer,
  payments,
  dashboards,
  spAdminDetails,
  mobileAppVersions,
  ...sharedReducers
});

export default rootReducer;
